import script from "./WideLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./WideLayout.vue?vue&type=script&setup=true&lang=js"

import "./WideLayout.vue?vue&type=style&index=0&id=dafdd7da&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dafdd7da"]])

export default __exports__